import { DialogLike } from "@obg/mat.ui.core";
import { TwoFactorAuthFlow } from "@obg/ngx.common";
import { TwoFactorAuthMethod } from "@obg/ngx.core";

import { VerificationCodeContainerComponent } from "./verification-code-container.component";

export const TWO_FACTOR_AUTHENTICATION_DIALOG_ID = "TWO_FACTOR_AUTHENTICATION_DIALOG";

interface TwoFactorAuthVerificationDialogFactoryProps {
	authFlow: TwoFactorAuthFlow;
	forceMethod?: TwoFactorAuthMethod | undefined;
	hideRememberDevice?: boolean;
	dialogId?: string;
	suspicious?: boolean;
	isAccountNotVerified?: boolean;
	xAuthToken?: string | undefined;
	newPhoneNumber?: string | undefined;
	disableOtpMethodSwitching?: boolean;
}

export function twoFactorAuthVerificationDialogFactory({
	authFlow,
	forceMethod,
	dialogId,
	hideRememberDevice = false,
	suspicious = false,
	isAccountNotVerified = false,
	xAuthToken = undefined,
	newPhoneNumber = undefined,
	disableOtpMethodSwitching = false,
}: TwoFactorAuthVerificationDialogFactoryProps): DialogLike<VerificationCodeContainerComponent> {
	return {
		dialogId: dialogId ?? TWO_FACTOR_AUTHENTICATION_DIALOG_ID,
		dialogComponentType: VerificationCodeContainerComponent,
		onClose$: (c) => c.close,
		init: (comp) => {
			comp.authFlow = authFlow;
			comp.forceMethod = forceMethod;
			comp.hideRememberDevice = hideRememberDevice;
			comp.suspiciousFlow = suspicious;
			comp.accountNotVerified = isAccountNotVerified;
			comp.xAuthToken = xAuthToken;
			comp.newPhoneNumber = newPhoneNumber;
			comp.disableOtpMethodSwitching = disableOtpMethodSwitching;
		},
	};
}
